function formatMessages({
  data,
  chatSettings,
  setFormatted,
  setLoading,
  setSearchResults,
  searching
}) {
  // Filter out cleared history first
  const clearHistoryDate = chatSettings?.clearHistoryDate;
  data = clearHistoryDate
    ? data?.filter((x) => new Date(x.createdAt) > new Date(clearHistoryDate))
    : data;

  if (!data?.length) return setFormatted([]);

  const newFormatted = [],
    fiveMinutes = 5 * 60 * 1000,
    oneDay = 24 * 60 * 60 * 1000;

  let tempDay = { data: [] },
    tempChunk = [],
    lastMessageTime = null,
    lastOwner = null;

  // The arrays go as follows from biggest to smallest
  // formatted -> days -> chunks -> messages

  data?.map((x) => {
    let creationDate = new Date(x.createdAt);
    lastMessageTime = lastMessageTime || creationDate;
    lastOwner = lastOwner || x.sender;

    //  If the last message and current message are from different days, push
    //  the most recent chunk onto the day, then push the day onto formatted,
    //  then reset the days and the chunks
    if (Math.floor(creationDate / oneDay) !== Math.floor(lastMessageTime / oneDay)) {
      tempDay.title = lastMessageTime;
      tempDay.data.push(tempChunk.reverse());
      tempChunk = [];

      newFormatted.push(tempDay);
      tempDay = { data: [] };

      //  If the last message and current message have more than 5 minutes
      //  inbetween, or have different senders push the chunk onto the day then
      //  reset the chunk
    } else if (lastMessageTime - creationDate > fiveMinutes || lastOwner !== x.sender) {
      tempDay.data.push(tempChunk.reverse());
      tempChunk = [];
    }

    lastOwner = x.sender;
    lastMessageTime = creationDate;
    tempChunk.push(x);

    return null;
  });

  tempDay.title = lastMessageTime;
  tempDay.data.push(tempChunk.reverse());

  newFormatted.push(tempDay);

  setLoading(false);
  searching ? setSearchResults(newFormatted) : setFormatted(newFormatted);
}

export default formatMessages;
